export default __webpack_public_path__ + "static/media/Divesh.fd58209d.png";